var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBtnPlus = function SvgBtnPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2536",
    transform: "translate(-659 -651)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 240",
    width: 24,
    height: 24,
    rx: 5,
    transform: "translate(659 651)",
    fill: "#ecf1f4"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 2485",
    d: "M667 663.593v-1.176h8v1.176Zm3.368-4.593h1.273v8h-1.273Z",
    fill: "currentColor"
  }))));
};
export default SvgBtnPlus;